import { type ActionItem } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { SettingsRoutes } from 'entities/ExportRouters'

export const verifyNumber = (): ActionItem => {
  return {
    icon: 'check2',
    text: 'Verify number',
    onAction: () =>
      uiStore.changeRouteViaVue({
        path: `/${SettingsRoutes.root}/${SettingsRoutes.compliance}`,
      }),
  }
}
